import NidApp from "./api.js";

;( function( $, NidApp, nidHouseGuide ) {

    $( function() {
        var uploader = null;
        var pluploadArgs = {
            runtimes: 'html5,html4',
            browse_button: 'browse-files',
            container: 'house-guide-image',
            url: nidHouseGuide.fileUploadUrl,
            dragdrop: true,
            multi_selection: false,
            autostart: true,
            drop_element: 'drag-drop-area',
            multipart_params: {
                postId: nidHouseGuide.postId,
                _nonce: nidHouseGuide.nonce
            },
            filters: {
                max_file_size: '5000kb',
                mime_types: [
                    {
                        title : 'Image Files',
                        extensions: 'jpg,gif,png,jpeg,pdf'
                    }
                ]
            },
            init: {

                Init: function( up ) {
                    // console.log( 'Init', up );
                },

                /** When a file is added */
                FilesAdded: function( up, files ) {
                    // console.log( 'FilesAdded', up, files, NHG.modalfileType );

                    if ( NHG.modalfileType === 'image' && files[0].type === 'application/pdf' ) {
                        NidApp.showMessage( nidHouseGuide.notImage, 'error' );

                        this.removeFile( files[0] );
                    }
                    else if ( NHG.modalfileType === 'pdf' && files[0].type !== 'application/pdf' ) {
                        NidApp.showMessage( nidHouseGuide.notPdf, 'error' );

                        this.removeFile( files[0] );
                    }
                    else {
                        // trigger the upload immediately.
                        $( 'body' ).addClass( 'files-uploading' );
                        NidApp.showLoadingIcon();
                        uploader.start();
                    }

                },

                /** Error callback. */
                Error: function( up, err ) {
                    NidApp.removeLoadingIcon();

                    // $( 'body' ).removeClass( 'files-uploading' );
                    // console.log( 'Error!', up, err );

                    if ( -600 === err.code ) {
                        $.event.trigger({ type: 'fileUploadedError', message: nidHouseGuide.fileTooLarge });
                    }
                },

                /** File uploaded callback. */
                FileUploaded: function( up, file, data ) {
                    $( 'body' ).removeClass( 'files-uploading' );
                    var result = JSON.parse( data.response );

                    // console.log( 'FileUploaded:', up, file, result );
                    NidApp.removeLoadingIcon();

                    if ( typeof result === 'object' && true === result.success ) {
                        if ( typeof result.data.url !== 'undefined' ) {
                            $.event.trigger({ type: 'fileUploaded', message: result.data });
                        }
                        else {
                            $.event.trigger({ type: 'fileUploadedError', message: result.data });
                        }
                    }
                    else {
                        $.event.trigger({ type: 'fileUploadedError', message: result.data });
                    }

                }

            }

        };

        var NHG = {};
        NHG.baseName = function( str ) {
            if ( '' === str || null === str ) {
                return '';
            }
            return String( str ).substring( str.lastIndexOf( '/' ) + 1 );
        };
        NHG.deleteFile = function( fileUrl ) {
            var data = {
                _nonce: nidHouseGuide.nonce,
                post_id: nidHouseGuide.postId,
                file_url: fileUrl
            };

            $.post( nidHouseGuide.ajaxUrl + 'delete-image', data ).done( function( result ) {
                // console.log( 'File deleted:', result );
            });
        };


        /**
         * Model: HouseGuide.
         */
        var HouseGuide = Backbone.Model.extend({
            defaults: {
                title: '',
                description: '',
                image: '',
                ID: '',
            }
        });


        /**
         * View: HouseGuideView.
         */
        var HouseGuideView = Backbone.View.extend({
            el: '#nid-house-guide-view-container',
            initialize: function() {
                var self = this;
                this.render();

                $( document ).on( 'fileUploaded', function( e ) {
                    self.updateModalImage( e.message.url );
                });

                if ( '' !== this.model.get( 'image' ) ) {
                    this.updateObjectImage( this.model.get( 'image' ) );
                }

                autosize( $( '#house-guide-desc' ) );
            },
            events: {
                'blur .input': 'triggerModalChange',
                'click a.nid-hg-modal-trigger': 'openModal',
                'click .nid-hg-image-model-placholder': 'triggerOpenModal',
                'click a.nid-hg-remove-image': 'removeImage',
                'click a#delete-house-guide': 'delete'
            },

            /** Render the view. */
            render: function() {
                var template = _.template( $( '#nid-hg-new-house-guide' ).html() )( this.model.toJSON() );

                this.$el.append( template );
            },

            /** Update the model when the view changes. */
            triggerModalChange: function( e ) {
                var $field = $( e.currentTarget ),
                    key = $field.data( 'key' ),
                    val = $field.val();

                this.model.set( key, val );
            },

            /** Open the uploader modal and set relevant flags. */
            openModal: function( e ) {
                e.preventDefault();

                var $currModal = $( e.currentTarget );

                NHG.modalType = $currModal.attr( 'data-type' );
                NHG.modalIndex = $currModal.attr( 'data-index' );
                NHG.modalfileType = $currModal.attr( 'data-file-type' );

                $currModal.magnificPopup({
                    type: 'inline',
                    preloader: false,
                    callbacks: {
                        open: function() {
                            if ( null === uploader ) {
                                uploader = new plupload.Uploader( pluploadArgs );
                                uploader.init();
                            }
                        }
                    }
                }).trigger( 'click' ); // Not sure why this is necessary, but it seems to be...
            },

            /** Trigger a click event on the button to open the modal. */
            triggerOpenModal: function( e ) {
                $( 'a.nid-hg-image-model' ).trigger( 'click' );
            },

            /** Update the modal when an image is added. */
            updateModalImage: function( url ) {
                if ( 'house-guide' === NHG.modalType ) {
                    this.model.set( 'image', url );
                    this.updateObjectImage( url );
                }
            },

            /** Update the view image. */
            updateObjectImage: function( url ) {
                var $image = $( '<img />', { src: url });
                this.$el.addClass( 'has-image' );
                $( '#house-guide-image-container' ).html( $image );
            },

            /** Remove the image from the DOM */
            removeImage: function( e ) {
                e.preventDefault();

                $( '#house-guide-image-container' ).empty();
                this.$el.removeClass( 'has-image' );

                NHG.deleteFile( this.model.get( 'image' ) );
                this.model.set({ 'image': '' });
            },

            delete: function( e ) {
                e.preventDefault();
                var data = {
                    _nonce: nidHouseGuide.nonce,
                    post_id: nidHouseGuide.postId,
                    nid_fast_ajax: 1
                };

                var confirm = window.confirm( nidHouseGuide.areYouSureHouseGuide );
                if ( false === confirm ) {
                    return;
                }

                NidApp.showLoadingIcon();

                $.post( nidHouseGuide.ajaxUrl + 'delete', data ).done( function( result ) {
                    NidApp.removeLoadingIcon();

                    // console.log( result );
                    if ( true === result.success ) {
                        NidApp.showMessage( nidHouseGuide.houseGuideDeleted );
                        setTimeout( function() {
                            window.location = nidHouseGuide.archiveUrl;
                        }, 1500 );
                    }
                    else {
                        NidApp.showMessage( nidHouseGuide.houseGuideError, 'error' );
                    }
                });
            },

        });


        /**
         * Model: RenovationObject.
         */
        var RenovationObject = Backbone.Model.extend({
            defaults: {
                ID: '',
                index: 0,
                title: '',
                description: '',
                date: '',
                underlay: '',
                prep: '',
                products: '',
                purchased: '',
                comments: '',
                pdf: '',
                images: [],
                category: '',
            },

            initialize: function() {
                var pdf = this.get( 'pdf' ),
                    pdfBasename = '',
                    imagesCollection;

                if ( '' !== pdf || null !== pdf ) {
                    pdfBasename = NHG.baseName( pdf );
                }
                this.set({ pdfBasename: pdfBasename });
            }
        });


        /**
         * Collection: RenovationObjects.
         * Model     : RenovationObject.
         */
        var RenovationObjects = Backbone.Collection.extend({
            model: RenovationObject,

            initialize: function() {
                this.bind( 'change:title', this.triggerCollectionReRender );
                this.bind( 'change:images', this.triggerCollectionReRender );
            },

            triggerCollectionReRender: function() {
                this.trigger( 'change', this );
            }
        });


        /**
         * View: RenovationObjectsView.
         *
         * View for the RenovationObjects collection.
         */
        var RenovationObjectsView = Backbone.View.extend({
            el: '#nid-renovation-objects-view-container',
            initialize: function() {
                this.render();

                this.listenTo( this.collection, 'add', this.render );
                this.listenTo( this.collection, 'remove', this.render );
                this.listenTo( this.collection, 'change', this.render );
            },

            events: {
                'click button.new-ren-obj': 'addNewRenovationObject',
                'click .house-guide-thumb a': 'editRenovationObject',
                'click #ro-filters-guide-list a': 'filterRenovationObjects'
            },

            /** Render the view. */
            render: function() {
                var $filters = this.maybeRenderRoFilters(),
                    template = _.template( $( '#nid-hg-renovation-objects' ).html() ),
                    $renObs = $( '<div class="ro-container" />' ),
                    $renOb;

                this.collection.each( function( model, i ) {
                    model.set( 'index', i );

                    $renOb = _.template( $( '#nid-hg-renovation-objects-list-view' ).html() )( model.toJSON() );
                    $renObs.append( $renOb );
                });

                this.$el.html( template );
                $( '#nid-hg-renovation-objects-container', this.$el ).html( $renObs );
                $( '#nid-hg-renovations-object-filters', this.$el ).html( $filters );
            },

            /** Render the renovation object filters if appropriate */
            maybeRenderRoFilters: function() {
                var indoor = this.collection.where({ category: 'indoor' }),
                    outdoor = this.collection.where({ category: 'outdoor' });

                if ( indoor.length > 0 && outdoor.length > 0 ) {
                    return this.renderRoFilters({ indoorCount: indoor.length, outdoorCount: outdoor.length });
                }

                return '';
            },

            /** Render the renovation object filters */
            renderRoFilters: function( args ) {
                return _.template( $( '#nid-hg-renovation-object-filters' ).html() )( args );
            },

            /** Edit a renovation object */
            editRenovationObject: function( e ) {
                e.preventDefault();

                var index = $( e.currentTarget ).data( 'index' );

                this.renderNewRoModel( this.collection.at( index ) );
            },

            /** Filter the renovation objects lits after 'category' */
            filterRenovationObjects: function( e ) {
                e.preventDefault();

                var cat = $( e.currentTarget ).data( 'cat' );

                if ( 'all' === cat ) {
                    $( '#nid-hg-renovation-objects-container .ro' ).show();
                }
                else {
                    $( '#nid-hg-renovation-objects-container .ro' ).hide();
                    $( '#nid-hg-renovation-objects-container .ro.cat-' + cat ).show();
                }
            },

            /** Add a new renovation object to the collection and render the view */
            addNewRenovationObject: function( e ) {
                e.preventDefault();

                var ro = new RenovationObject({ index: this.collection.length });
                NHG.renObjCollection.push( ro );

                this.renderNewRoModel( ro );
            },

            /** Render the view for a renovation object */
            renderNewRoModel: function( model ) {
                if ( 'object' === typeof NHG.nidHgRenovationObjectView ) {
                    NHG.nidHgRenovationObjectView.remove();
                }

                NHG.nidHgRenovationObjectView = new RenovationObjectView({ model: model });

                var $template = $( '#nid-house-guide-renovation-object-container' ).empty();
                $template.html( NHG.nidHgRenovationObjectView.render() );

                $( 'body, html' ).animate({ scrollTop: $template.offset().top - 10 }, 500 );

                autosize( $( '.renovation-object textarea' ) );
            }

        });


        /**
         * View: RenovationObjectView.
         */
        var RenovationObjectView = Backbone.View.extend({
            className: 'renovation-object',
            initialize: function() {
                var self = this;

                if ( '' !== this.model.get( 'pdf' ) ) {
                    this.$el.addClass( 'has-pdf' );
                }
            },

            events: {
                'blur .input': 'triggerModalChange',
                'change #renovation-object-cat': 'triggerCategoryChange',
                'click a.nid-hg-modal-trigger': 'openModal',
                'click .nid-hg-image-model-placholder': 'triggerOpenModal',
                'click a.ro-remove': 'removeModel',
                'click a.nid-ro-remove-image' : 'removeImage',
                'click a.nid-ro-remove-pdf' : 'removePdf',
                'click button.close': 'closeView'
            },

            /**
             * Render the view.
             *
             * This method returns the template as we'll use it in a nested
             * template.
             *
             * @return {string} The compiled template.
             */
            render: function() {
                this.$el.empty();

                var template = _.template( $( '#nid-hg-new-renovation-object' ).html() )( this.model.toJSON() );
                this.$el.html( template );

                $( '.date-picker', this.$el ).pickadate({
                    monthsFull: nidHouseGuide.monthsFull,
                    monthsShort: nidHouseGuide.monthsShort,
                    weekdaysFull: nidHouseGuide.weekdaysFull,
                    weekdaysShort: nidHouseGuide.weekdaysShort,
                    showMonthsShort: false,
                    showWeekdaysFull: false,
                    today: nidHouseGuide.today,
                    clear: nidHouseGuide.clear,
                    close: nidHouseGuide.close,
                    labelMonthNext: nidHouseGuide.labelMonthNext,
                    labelMonthPrev: nidHouseGuide.labelMonthPrev,
                    labelMonthSelect: nidHouseGuide.labelMonthSelect,
                    labelYearSelect: nidHouseGuide.labelYearSelect,
                    format: 'yyyy-mm-d',
                    onSet: function( data ) {
                        // Trigger the blur event after the date is selected
                        // in order to update the model.
                        $( '.date-picker' ).trigger( 'blur' );
                    }
                });

                if ( '' !== this.model.get( 'category' ) ) {
                    $( '#renovation-object-cat', this.$el ).val( this.model.get( 'category' ) );
                }
                $( '#renovation-object-cat', this.$el ).select2();

                return this.el;
            },

            /** Update the model when the view changes. */
            triggerModalChange: function( e ) {
                var $field = $( e.currentTarget ),
                    key = $field.attr( 'data-key' ),
                    val = $field.val();

                this.model.set( key, val );
            },

            /** Updat the model category */
            triggerCategoryChange: function( e ) {
                var val = $( e.currentTarget ).val();

                this.model.set( 'category', val );
            },

            /** Open the modal dialog. */
            openModal: function( e ) {
                e.preventDefault();

                var $currModal = $( e.currentTarget ),
                    images = this.model.get( 'images' );

                NHG.modalType = $currModal.attr( 'data-type' );
                NHG.modalIndex = +$currModal.attr( 'data-index' );
                NHG.modalfileType = $currModal.attr( 'data-file-type' );

                if ( 5 === images.length && 'image' === NHG.modalfileType ) {
                    NidApp.showMessage( nidHouseGuide.maxFiveImages, 'error' );
                    return;
                }

                $currModal.magnificPopup({
                    type: 'inline',
                    preloader: false,
                    callbacks: {
                        open: function() {
                            if ( null === uploader ) {
                                uploader = new plupload.Uploader( pluploadArgs );
                                uploader.init();
                            }
                        }
                    }
                }).trigger( 'click' ); // Not sure why this is necessary, but it seems to be...
            },

            triggerOpenModal: function( e ) {
                $( 'a.nid-hg-image-model', this.$el ).trigger( 'click' );
            },

            /** Update the models image. */
            updateModalImage: function( url ) {
                var index = this.model.get( 'index' ),
                    self = this;

                if ( 'renovation-object' === NHG.modalType && NHG.modalIndex === index ) {
                    this.model.set( NHG.modalfileType, url );

                    if ( 'image' === NHG.modalfileType ) {
                        this.addImage( url );
                    }
                    else if ( 'pdf' === NHG.modalfileType ) {
                        this.updateObjectPdf( url );
                        this.$el.addClass( 'has-pdf' );
                    }
                }
            },

            /** Update the view image. */
            addImage: function( url ) {
                var images = _.clone( this.model.get( 'images' ) );

                images.push( url );

                var $image = $( '<img />', { src: url }),
                    index = images.length - 1;

                this.model.set( 'images', images );

                var template = _.template( $( '#nid-hg-ro-image' ).html() )({ image: url, i: index });
                $( '#renovation-object-images-container' ).append( template );
            },

            /** Remove the image from the DOM */
            removeImage: function( e ) {
                e.preventDefault();

                var index = +$( e.currentTarget ).attr( 'data-index' ),
                    images = _.clone( this.model.get( 'images' ) );

                $( '#ro-image-idex-' + index ).remove();
                NHG.deleteFile( images[ index ] );

                images.splice( index, 1 );

                this.model.set( 'images', images );

                this.reRenderImages();
            },

            /**
             * Re render the images after deletion so that
             * they get their correct indexes in the markup.
             */
            reRenderImages: function() {
                $( '#renovation-object-images-container' ).empty();

                _.each( this.model.get( 'images' ), function( image, i ) {
                    var template = _.template( $( '#nid-hg-ro-image' ).html() )({ image: image, i: i });
                    $( '#renovation-object-images-container' ).append( template );
                });
            },

            /** Update the view image. */
            updateObjectPdf: function( url ) {
                var link = '<span>' + nidHouseGuide.attachedPDF + ':</span> <a target="_blank" href="' + url + '">' + NHG.baseName( url ) + '</a>';
                $( '#renovation-object-pdf-container', this.$el ).html( link );
            },

            /** Remove the model from the collection. */
            removeModel: function( e ) {
                e.preventDefault();

                var model = NHG.renObjCollection.findWhere({ index: this.model.get( 'index' ) });
                NHG.renObjCollection.remove( model );

                this.destroyView( true );

                $( '#nid-submit-container .save' ).trigger( 'click' );
            },

            /** Remove the image from the DOM */
            removePdf: function( e ) {
                e.preventDefault();

                $( '#renovation-object-pdf-container', this.$el ).empty();
                this.$el.removeClass( 'has-pdf' );

                NHG.deleteFile( this.model.get( 'pdf' ) );
                this.model.set({ 'pdf': '' });
            },

            /** Close the model view */
            closeView: function( e ) {
                e.preventDefault();

                this.destroyView( true );

                $( '#nid-submit-container .save' ).trigger( 'click' );
            },

            /** It does what it says */
            destroyView: function( animate ) {
                animate = animate || false;

                this.remove();
                this.unbind();
                this.undelegateEvents();
                this.$el.removeData().unbind();
                this.$el.empty();

                if ( true === animate ) {
                    $( 'body, html' ).animate({ scrollTop: $( '#nid-renovation-objects-view-container' ).offset().top - 120 }, 500 );
                }
            }

        });


        /**
         * View: CreateHouseGuideView.
         *
         * This view contins multiple nestled views for creating
         * a house guide wirth respective renovation objects.
         */
        var CreateHouseGuideView = Backbone.View.extend({
            el: '#nid-submit-container',
            events: {
                'click button.save': 'saveTrigger'
            },

            /** Trigger the save event. */
            saveTrigger: function( e ) {
                e.preventDefault();
                var self = this;

                $.when( this.save() ).done( function( result ) {
                    if ( true === result.success ) {
                        NidApp.showMessage( nidHouseGuide.houseGuideSaved );
                        self.updateRoIds( result.data.renovation_objects.post_ids );
                    }
                    else {
                        NidApp.showMessage( nidHouseGuide.houseGuideError, 'error' );
                    }
                });
            },

            /** Save the house guide and all related data. */
            save: function( background ) {
                var data = {
                        _nonce: nidHouseGuide.nonce,
                        house_guide: NHG.houseGuide.toJSON(),
                        renovation_objects: NHG.renObjCollection.toJSON(),
                        user_id: nidHouseGuide.userId,
                        nid_fast_ajax: 1
                    },
                    deferred = $.Deferred();

                background = background || false;

                if ( '' === data.house_guide.title ) {
                    NidApp.showMessage( nidHouseGuide.noTitle, 'error' );
                    $( '#house-guide-title' ).focus();
                    return;
                }

                if ( false === background ) {
                    NidApp.showLoadingIcon();
                }

                $.post( nidHouseGuide.ajaxUrl + 'save', data ).done( function( result ) {
                    if ( false === background ) {
                       NidApp.removeLoadingIcon();
                    }

                    deferred.resolve( result );
                });

                return deferred.promise();
            },

            /**
             * If a renovation object has been created in Backbone it
             * will need to be assigned an ID from the saved post in
             * the database, otherwise multiple posts will be created
             * every time the house guide is updated via AJAX.
             *
             * @param {array} roIds Array of renovation object IDs
             *                      (in the same order as the models
             *                       in the collection)
             */
            updateRoIds: function( roIds ) {
                if ( roIds.length > 0 ) {
                    NHG.renObjCollection.each( function( model, i ) {
                        if ( '' === model.get( 'ID' ) ) {
                            model.set({ ID: roIds[i] });
                        }
                    });
                }
            }

        });


        /**
         * View: HouseGuideActionsView.
         *
         * This view contins multiple nestled views for creating
         * a house guide wirth respective renovation objects.
         */
        var HouseGuideActionsView = Backbone.View.extend({
            el: '#email-house-guide-view',
            initialize: function() {
                $( '#nid-hg-stores-list' ).select2();
            },
            events: {
                'click a#email-house-guide': 'toggleEmailBox',
                'submit .email-house-guide form': 'triggerSendEmail',
                'submit #house-guide-print-form': 'saveAndRedirectToPdfEndpoint'
            },

            /**
             * Show/hide the email house guide box.
             */
            toggleEmailBox: function( e ) {
                e.preventDefault();

                var $this = $( e.currentTarget );

                $this.toggleClass( 'visible' );
                if ( $this.hasClass( 'visible' ) ) {
                    $( 'body, html' ).animate({ scrollTop: $this.offset().top - 50 }, 500 );
                    $this.find( 'span' ).text( nidHouseGuide.hideEmailBox );
                }
                else {
                    $this.find( 'span' ).text( nidHouseGuide.showEmailBox );
                }

                $( '.email-house-guide' ).toggleClass( 'visible' );
            },

            triggerSendEmail: function( e ) {
                e.preventDefault();

                var self = this;

                NidApp.showLoadingIcon();

                // Save the houseguide first, just in case the user forgot.
                $.when( NHG.createHouseGuide.save( true ) ).done( function( result ) {
                    if ( true === result.success ) {
                        NHG.createHouseGuide.updateRoIds( result.data.renovation_objects.post_ids );

                        $.when( self.sendEmail() ).done( function( result ) {
                            NidApp.removeLoadingIcon();
                            // console.log( result );

                            // If result is a string it's is an error from TCPDF
                            if ( typeof result === 'string' ) {
                                NidApp.showMessage( result, 'error' );

                            } else {
                                if ( true === result.success ) {
                                    NidApp.showMessage( nidHouseGuide.emailSent );
                                    setTimeout( function() {
                                        $( 'body, html' ).animate({
                                            scrollTop: $( '#nid-renovation-objects-view-container' ).offset().top - 120
                                        }, 500, function() {
                                            $( 'a#email-house-guide' ).removeClass( 'visible' ).find( 'span' ).text( nidHouseGuide.showEmailBox );
                                            $( '.email-house-guide' ).removeClass( 'visible' );
                                        });
                                    }, 1000 );
                                }
                                else {
                                    NidApp.showMessage( result.data, 'error' );
                                }
                            }

                        });
                    }
                    else {
                        NidApp.removeLoadingIcon();
                        NidApp.showMessage( nidHouseGuide.houseGuideError, 'error' );
                    }
                });
            },

            /**
             * Email the form to a store.
             */
            sendEmail: function() {
                var $storesList = $( '#nid-hg-stores-list' ),
                    data = {
                        _nonce: nidHouseGuide.nonce,
                        post_id: nidHouseGuide.postId,
                        blog_id: +$storesList.val(),
                        email_address: $( '#hg-email-address' ).val(),
                        message: $( '#hg-email-message' ).val(),
                        send_copy: ( $( '#hg-send-me-a-copy' ).is( ':checked' ) ) ? 'yes' : 'no',
                        no_1_club: ( $( '#hg-no-1-club' ).is( ':checked' ) ) ? 'yes' : 'no',
                        nid_fast_ajax: 1
                    },
                    deferred = $.Deferred();

                if ( 0 === data.blog_id && '' === data.email_address ) {
                    deferred.resolve({ success: false, data: nidHouseGuide.selectStoreOrEmail });
                }

                $.post( nidHouseGuide.ajaxUrl + 'email-guide', data ).done( function( result ) {
                    deferred.resolve( result );
                });

                return deferred.promise();

            },

            /** Save the form before generating the PDF */
            saveAndRedirectToPdfEndpoint: function( e ) {
                var $form = $( e.currentTarget );

                if ( ! $form.hasClass( 'saved' ) ) {
                    e.preventDefault();
                    NidApp.showLoadingIcon();

                    $.when( NHG.createHouseGuide.save( true ) ).done( function( result ) {
                        NidApp.removeLoadingIcon();

                        $form.addClass( 'saved' ).trigger( 'submit' );

                        setTimeout( function() {
                            $form.removeClass( 'saved' );
                        }, 500 );
                    });
                }
            }
        });



        // Render the main view.
        NHG.createHouseGuide = new CreateHouseGuideView();
        NHG.HouseGuideActions = new HouseGuideActionsView();

        // Render the house guide and related view.
        NHG.houseGuide = new HouseGuide({
            ID: nidHouseGuide.houseGuide.ID,
            title: nidHouseGuide.houseGuide.post_title,
            description: nidHouseGuide.houseGuide.post_content,
            image: nidHouseGuide.houseGuideImage
        });
        NHG.houseGuideView = new HouseGuideView({ model: NHG.houseGuide });

        // Render the renovation objects collection and view.
        NHG.renObjCollection = new RenovationObjects( nidHouseGuide.renovationObj );
        NHG.renObjView = new RenovationObjectsView({ collection: NHG.renObjCollection });;

        $( document ).on( 'fileUploaded', function( e ) {
            $.magnificPopup.close();
        });

        $( document ).on( 'fileUploadedError', function( e ) {
            NidApp.showMessage( e.message, 'error' );
        });

        $( document ).on( 'fileUploaded', function( e ) {
            if ( 'object' === typeof NHG.nidHgRenovationObjectView ) {
                NHG.nidHgRenovationObjectView.updateModalImage( e.message.url );
            }
        });

    });

}( jQuery, NidApp, nidHouseGuide ));
